// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#HomeDeck {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 100px); /* Subtract navbar height */
  width: 100vw;
  overflow: hidden;
  position: relative;
}

#HomeDeck .animated {
  position: absolute;
  /* height: 10vh; */
  will-change: transform;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

#HomeDeck .homeAnimated {
  z-index: 2;
}

#HomeDeck .animated > .card {
  position: absolute;
  width: 68vw;
  max-width: 300px;
  max-height: 500px;
  padding: 0px;
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 10px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

#HomeDeck .loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#HomeDeck .load-button {
  background: linear-gradient(135deg, #ff5e5e, #ff9966);
  color: white;
  border-radius: 30px;
  padding: 10px 20px;
  box-shadow: rgba(40, 40, 40, 0.35) 0px 5px 15px;
  border: none;
  cursor: pointer;
  font-size: 1.5em;
  font-weight: bold;
  transition: all 0.3s ease;
  text-align: center;
  margin: 4px;
}

#HomeDeck .load-button:hover {
  transform: scale(1.05);
  box-shadow: 0px 5px 20px rgba(255, 153, 102, 0.5);
}

#HomeDeck .load-button:active {
  transform: scale(0.95);
  box-shadow: 0px 3px 10px rgba(255, 153, 102, 0.3);
}

#HomeDeck .like-dislike-indicator {
  z-index: 4;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10rem;
  color: white;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

#HomeDeck .load-button:before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  border-radius: 30px;
  background: linear-gradient(135deg, #ff9966, #ff5e5e);
  box-shadow: 0 0 1px rgba(255, 153, 102, 0.4);
  animation: pulse 2s infinite;
}
`, "",{"version":3,"sources":["webpack://./src/assets/HomeDeck.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B,EAAE,2BAA2B;EACxD,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,qDAAqD;EACrD,4CAA4C;EAC5C,4BAA4B;AAC9B","sourcesContent":["#HomeDeck {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: calc(100vh - 100px); /* Subtract navbar height */\n  width: 100vw;\n  overflow: hidden;\n  position: relative;\n}\n\n#HomeDeck .animated {\n  position: absolute;\n  /* height: 10vh; */\n  will-change: transform;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n#HomeDeck .homeAnimated {\n  z-index: 2;\n}\n\n#HomeDeck .animated > .card {\n  position: absolute;\n  width: 68vw;\n  max-width: 300px;\n  max-height: 500px;\n  padding: 0px;\n  background-color: white;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  border-radius: 10px;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\n}\n\n#HomeDeck .loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n#HomeDeck .load-button {\n  background: linear-gradient(135deg, #ff5e5e, #ff9966);\n  color: white;\n  border-radius: 30px;\n  padding: 10px 20px;\n  box-shadow: rgba(40, 40, 40, 0.35) 0px 5px 15px;\n  border: none;\n  cursor: pointer;\n  font-size: 1.5em;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  text-align: center;\n  margin: 4px;\n}\n\n#HomeDeck .load-button:hover {\n  transform: scale(1.05);\n  box-shadow: 0px 5px 20px rgba(255, 153, 102, 0.5);\n}\n\n#HomeDeck .load-button:active {\n  transform: scale(0.95);\n  box-shadow: 0px 3px 10px rgba(255, 153, 102, 0.3);\n}\n\n#HomeDeck .like-dislike-indicator {\n  z-index: 4;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 10rem;\n  color: white;\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n#HomeDeck .load-button:before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  opacity: 0;\n  border-radius: 30px;\n  background: linear-gradient(135deg, #ff9966, #ff5e5e);\n  box-shadow: 0 0 1px rgba(255, 153, 102, 0.4);\n  animation: pulse 2s infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
